import React, { useState } from 'react'
import { SiteForm } from '../../models/site.model'
import { SubmitHandler } from 'react-hook-form'
import { createSite, deleteSite } from '../../services/site.service'
import { Link, Typography } from '@mui/material';
import HandleForm from './HandleForm'
import { useNavigate } from 'react-router-dom';
import { useProject } from '../../context/ProjectContext';
import { APIResponseModel } from '../../models/api-call';
import { editSite } from '../../services/site.service';
import useUser from "../../hooks/useUser";
import ConfirmModal from '../common/ConfirmModal';
import IndicatorChip from '../common/ActionChip/IndicatorChip';
import PrimaryMenuBar from '../SiteActions/SiteViewActions';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { useNotification } from '../../context/NotificationContext';


interface SiteCreateFormProps {
  siteForm: SiteForm,
  site_code?: string,
  setBlockScreen: (p: boolean) => void;
  handleChange?: (e: any) => void;
  handleSelection: (...args: any[]) => void;
  action: string
}

const SiteCreateForm: React.FC<SiteCreateFormProps> = ({
  siteForm,
  site_code = '',
  setBlockScreen,
  handleSelection,
  handleChange,
  action }) => {
    const navigate = useNavigate()
    const { selectedProject } = useProject()
    const { showNotification } = useNotification();

    const [currentAction, setCurrentAction] = useState<string>(action)
    const [openConfirmRemoveModal, setOpenConfirmRemoveModal] = useState(false)
    const { userAdmin } = useUser()

    const onSubmit: SubmitHandler<SiteForm> = () => {
      setBlockScreen(true);
      Promise.all([currentAction === 'create' ? createSite(selectedProject, siteForm) :
        editSite(selectedProject, site_code, siteForm)]).then(function (results: APIResponseModel[]) {
          showNotification(
            <Typography component='span'>
              <i>Ver Sitio </i>
              <Link
                sx={{ color: 'darkblue', fontWeight: 'bold', fontStyle: 'italic' }}
                underline='hover'
                href={`/${selectedProject}/site/view/${results[0].data['site_code']}`}
              >
                {results[0].data['site_name']}
              </Link>
            </Typography>)
        setBlockScreen(false);
        navigate("/sites/listing")
      }).catch((error) => {
        showNotification(error.response.data.message, 'error')
        setBlockScreen(false)
      });
  };

  const onSubmitDelete = () => {
    setBlockScreen(true)
    Promise.all([deleteSite(selectedProject, site_code)]).then(function () {
      showNotification(<span>Se ha removido el Sitio: <i>{siteForm.name}</i></span>)
      setOpenConfirmRemoveModal(false)
      setBlockScreen(false)
      navigate('/sites/listing')
    }).catch((error) => {
      setOpenConfirmRemoveModal(false)
      showNotification(error.response.data.message, 'error')
      setBlockScreen(false)
      setTimeout(() => navigate('/sites/listing'), 1500)
    });
  }

  return (
    <React.Fragment>
      {currentAction !== 'create' &&

        (<div className='site-indicators-actions-section'>
          <div className='site-inidicators-section'>
            <IndicatorChip
              label={`Fecha de creación ${siteForm.created_date}`}
              iconDecoration={<EventAvailableOutlinedIcon />}
            />
          </div>

          <PrimaryMenuBar
            action={currentAction}
            setCurrentAction={setCurrentAction}
            handleRemove={() => setOpenConfirmRemoveModal(true)}
            canEdit={userAdmin}
          />
        </div>
        )}

      <HandleForm
        action={currentAction}
        handleChange={handleChange}
        handleSelection={handleSelection}
        setBlockScreen={setBlockScreen}
        onSubmit={onSubmit}
        siteForm={siteForm}
      />

      <ConfirmModal
      openModal={openConfirmRemoveModal}
      handleCloseModal={() => setOpenConfirmRemoveModal(false)}
      handleConfirm={onSubmitDelete}
    >
      <p>¿ Remover Sitio: {siteForm.name} ?</p>
      </ConfirmModal>

    </React.Fragment>
  );
}

export default SiteCreateForm;
